import { type APIConfig } from '../apiTypes'
import { axiosInstance } from './axiosInstance'

const axios = axiosInstance()

interface Response {
  list: {
    contextId: string
    configResult?: any
    chosenValues: number[]
  }[]
}

export const postLfcConfigresultList = async <T = any>(args: {
  apiConfigs: APIConfig
  data: {
    list: any[]
  }
  onSuccess: (response: { data: Response }) => T
}): Promise<T> => {
  const { onSuccess } = args
  const { marketCode, lfcApiBaseUrl } = args.apiConfigs
  const { list } = args.data

  return await axios<Response>({
    method: 'post',
    url: `${lfcApiBaseUrl}/multimallis/configresultlist`,
    params: {
      marketCode,
      useCache: true,
    },
    data: {
      list,
    },
  })
    .then((response) => onSuccess(response))
    .catch((error) => {
      console.error(error)
      throw new Error(JSON.stringify(error))
    })
}

export type PostLfcConfigresultList = typeof postLfcConfigresultList
